import { ValidationErrorData } from './common';

export interface CampaignPlaceEditorData {
    pageId: string;
    placeId: string;
    isOpen: boolean;
    errors: ValidationErrorData[];
}

export type CampaignPlaceEditorState = Record<string, CampaignPlaceEditorData>;

export enum CampaignPlaceEditorError {
    EMPTY_PLACE_ID = 'EMPTY_PLACE_ID',
    PLACE_ID_IS_NAN = 'PLACE_ID_IS_NAN',
    PLACE_INVALID_VALUE = 'DefectIds.INVALID_VALUE'
}

export const campaignPlaceEditorPlaceErrors = [
    CampaignPlaceEditorError.EMPTY_PLACE_ID,
    CampaignPlaceEditorError.PLACE_ID_IS_NAN,
    CampaignPlaceEditorError.PLACE_INVALID_VALUE
];
